module.exports = __webpack_public_path__ + "static/media/derby.215e472f.png";